import { IValidationTelemetryProperties } from './ITelemetry';

export function sendTelemetry(message: string, properties: IValidationTelemetryProperties) {
  window.parent.postMessage({
    message,
    properties
  }, API_TOKEN_RESOURCE)
}
